import { render, staticRenderFns } from "./platformHouseholdAdd.vue?vue&type=template&id=75578712&scoped=true"
import script from "./platformHouseholdAdd.vue?vue&type=script&lang=js"
export * from "./platformHouseholdAdd.vue?vue&type=script&lang=js"
import style0 from "./platformHouseholdAdd.vue?vue&type=style&index=0&id=75578712&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75578712",
  null
  
)

export default component.exports